import React, { Component } from 'react';

import Select from 'react-select';

import ErrorSummary from '../components/error-summary';
import ActivityIndicator from '../components/activity-indicator'
import authentication_api from '../api/authentication';

interface Props {
    isOpen: boolean;
    onClose: () => void;
}

interface State {
    loading: boolean;
    errorMessages: string[];
    saml_providers: any[];
    selected_saml_provider: any | null;
    certificate: string;
    entity_idp_id: string;
    sso_url: string;
}

class ModalSamlSettings extends Component<Props, State> {

    constructor(props: Props) {
        super(props);
        this.state = {
            loading: false,
            errorMessages: [],
            saml_providers: [],
            selected_saml_provider: null,
            certificate: '',
            entity_idp_id: '',
            sso_url: '',
        };

        this.onChange = this.onChange.bind(this);
        this.onClickSave = this.onClickSave.bind(this);
        this.getAllOrgSamlProviders = this.getAllOrgSamlProviders.bind(this);
        this.getOrgSamlSettings = this.getOrgSamlSettings.bind(this);
        this.onSelectChange = this.onSelectChange.bind(this);
    }

    async componentDidMount() {
        // get current saml settings
        try{
            await this.getAllOrgSamlProviders();
        }
        catch (error) {
            // @ts-ignore
            this.setState({ errorMessages: [error.message] });
        }
        finally {
            this.setState({ loading: false });
        }
    }

    async resetState() {
        this.setState({
            loading: false,
            errorMessages: [],
            selected_saml_provider: null,
            certificate: '',
            entity_idp_id: '',
            sso_url: '',
        })
    }

    async getAllOrgSamlProviders() {
        this.setState({ errorMessages: [], loading: true });
        try{
            let all_saml_providers = await authentication_api.get_all_saml_providers();

            this.setState({
                saml_providers: all_saml_providers.map((provider: any) => ({
                    value: provider.id,
                    label: provider.entity_idp_id
                })),
                loading: false
            })
        }
        catch(e){
            // @ts-ignore
            this.setState({ errorMessages: [e.message], loading: false });
        }
    }

    async getOrgSamlSettings(provider_id: string) {
        this.setState({ errorMessages: [], loading: true });
        try{
            let samlSettings = await authentication_api.get_saml_settings(provider_id);

            if (samlSettings){
                if (samlSettings) {

                    this.setState({
                        certificate: samlSettings.certificate || '',
                        entity_idp_id: samlSettings.entity_idp_id || '',
                        sso_url: samlSettings.sso_url || '',
                    });
                }
            }

            this.setState({ errorMessages: [], loading: false });
        }
        catch(e){
            // @ts-ignore
            this.setState({ errorMessages: [e.message], loading: false });
        }
    }

    onChange(e: any) {
        // @ts-ignore
        this.setState({ [e.target.name]: e.target.value })
    }

    async onSelectChange(selectedOption: any) {
        try{
            this.setState({ selected_saml_provider: selectedOption, errorMessages: [], loading: true });

            let provider_id = selectedOption ? selectedOption.value : null;

            if (provider_id == null) {
                this.resetState();
            }
            else{
                await this.getOrgSamlSettings(provider_id);
            }

            this.setState({ errorMessages: [], loading: false });
        }
        catch(e){
            // @ts-ignore
            this.setState({ errorMessages: [e.message], loading: false });
        }

    }

    async onClickSave() {
        this.setState({ errorMessages: [], loading: true })
        try {
            let payload = {
                provider_id: this.state.selected_saml_provider ? this.state.selected_saml_provider.value : null,
                certificate: this.state.certificate,
                entity_idp_id: this.state.entity_idp_id,
                sso_url: this.state.sso_url,
                api_base_url: process.env.REACT_APP_ROOT_API_URL
            }

            let response = await authentication_api.save_saml_settings(payload);

            if (response) {
                this.props.onClose();
            } else {
                this.setState({ errorMessages: ['Failed to save SAML settings.'] });
            }

        } catch (error) {
            // @ts-ignore
            this.setState({ errorMessages: [error.message] })
        } finally {
            this.setState({ loading: false })
        }
    }

    render() {
        return (
            <div role="dialog"
                onClick={() => this.props.onClose()}
                style={{ display: ((this.props.isOpen) ? 'block' : 'none') }}
                className={"modal fade " + ((this.props.isOpen) ? 'in' : '')}>


                <div className="modal-dialog modal-lg" role="document" onClick={(e) => e.stopPropagation()}>
                    <div className="modal-content">
                        <div className="modal-header">
                            <button
                                onClick={() => this.props.onClose()}
                                type="button" className="close" data-dismiss="modal" aria-label="Close">
                                <i className="fa fa-close"></i>
                            </button>
                            <h4 className="modal-title text-white text-capitalize">SAML Settings</h4>
                        </div>
                        <div className="modal-body">

                            <ErrorSummary errorMessages={this.state.errorMessages} />

                            <React.Fragment>

                                <div className="row">
                                    <div className="col-md-8 col-xs-12">
                                        <div className="form-group">
                                            <label className="font-weight-600 text--capitalize">Providers</label>
                                            <Select
                                                value={this.state.selected_saml_provider}
                                                onChange={(item) => {
                                                    this.onSelectChange(item);
                                                }}
                                                className='react-select-container'
                                                classNamePrefix="react-select"
                                                isClearable={true}
                                                placeholder=""
                                                options={this.state.saml_providers}
                                            />
                                        </div>
                                    </div>
                                </div>

                                <div className="row">
                                    <div className="col-md-8 col-xs-12">
                                        <div className="form-group">
                                            <label className="font-weight-600 text--capitalize">Certificate</label>
                                            <input
                                                name="certificate"
                                                value={this.state.certificate}
                                                onChange={(e) => this.onChange(e)}
                                                type="text" className="form-control" placeholder="Certificate" />
                                        </div>
                                    </div>
                                </div>

                                <div className="row">
                                    <div className="col-md-8 col-xs-12">
                                        <div className="form-group">
                                            <label className="font-weight-600 text--capitalize">Entity IDP ID</label>
                                            <input
                                                name="entity_idp_id"
                                                value={this.state.entity_idp_id}
                                                onChange={(e) => this.onChange(e)}
                                                type="text" className="form-control" placeholder="Entity IDP ID" />
                                        </div>
                                    </div>
                                </div>

                                <div className="row">
                                    <div className="col-md-8 col-xs-12">
                                        <div className="form-group">
                                            <label className="font-weight-600 text--capitalize">SSO URL</label>
                                            <input
                                                name="sso_url"
                                                value={this.state.sso_url}
                                                onChange={(e) => this.onChange(e)}
                                                type="text" className="form-control" placeholder="SSO URL" />
                                        </div>
                                    </div>
                                </div>

                            </React.Fragment>

                        </div>
                        <div className="modal-footer">
                            <button
                                onClick={() => this.props.onClose()}
                                className="btn btn-light-outline no-margin-right">Cancel</button>
                            <button
                                onClick={() => this.onClickSave()}
                                className="btn btn-dark">{this.state.selected_saml_provider ? "Update" : "Add"}</button>

                            <ActivityIndicator
                                modal={true}
                                loading={this.state.loading}
                            />

                        </div>
                    </div>
                </div>
            </div>

        )
    }

}

export default ModalSamlSettings;
